// extracted by mini-css-extract-plugin
export default {"AppLink":"AppLink--PSLjS"};